import script from "./MyAchievements.vue?vue&type=script&setup=true&lang=js"
export * from "./MyAchievements.vue?vue&type=script&setup=true&lang=js"

import "./MyAchievements.vue?vue&type=style&index=0&id=32d97c21&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32d97c21"]])

export default __exports__